
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({
  template: `
  <div class='two-columns'>
    <div>
      <a
        v-for="category in productsFirstColumn"
        :href="category.url"
        :title="category.title"
      >
        {{ category.title }}
      </a>
    </div>
    <div>
      <a
        v-for="category in productsSecondColumn"
        :href="category.url"
        :title="category.title"
      >
        {{ category.title }}
      </a>
    </div>
  </div>
  `
})
export default class FooterProducts extends Mixin {
  @Prop() products: any

  sortedProducts = []
  productsFirstColumn = []
  productsSecondColumn = []

  created() {
    this.sortedProducts = this.products.toSorted((a: any, b: any) => b.priority - a.priority)
    const mid = Math.ceil(this.sortedProducts.length / 2);
    this.productsFirstColumn = this.sortedProducts.slice(0, mid);
    this.productsSecondColumn = this.sortedProducts.slice(mid);
  }
}
